/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-08 14:34:41
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-14 17:13:25
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/product/index.ts
 */
import { post, remove, get } from 'src/tools/server';
import { ILinkProductCustomization } from 'src/types/common/SalesChannel';
import { networkSuccessCb as _successCb } from 'src/tools/helper';
import { EnumSiderEvent } from 'src/types/common/sider';

const successCb = () => {
  _successCb(EnumSiderEvent.salesChannelProduct);
};

export const request_linkProductDetail = (
  salesChannelUuid: string,
  salesChannelProductUuid?: string,
  params?: any,
) => {
  return post<any>(
    `/portal/salesChannelProduct/initialise`,
    {
      salesChannelUuid,
      salesChannelProductUuid,
    },
    params || {},
  );
};

export const request_linkProductList = (salesChannelUuid: string) => {
  return post<any>(`/portal/salesChannelProducts/${salesChannelUuid}`, {}, {});
};

export const request_hideProduct = (productUuid) => {
  return post<any>(`/portal/salesChannelProduct/hide/${productUuid}`, {}, {});
};

export const request_showProduct = (productUuid) => {
  return post<any>(`/portal/salesChannelProduct/show/${productUuid}`, {}, {});
};

export const request_deleteProduct = (productUuid) => {
  return remove<any>(`/portal/salesChannelProduct/${productUuid}`, {});
};

export const duplicate_salesChannelProducts = (salesChannelUuid, body) => {
  return post<any>(
    `/portal/salesChannelProducts/${salesChannelUuid}/duplicate`,
    body,
    {},
  );
};

export const request_productListInit = (
  salesChannelUuid,
  startIndex,
  maxCount,
  body,
  params = {},
) => {
  return post<any>(
    `/portal/salesChannelProductsPage/${salesChannelUuid}/${startIndex}/${maxCount}`,
    body,
    { ...(params ? params : {}) },
  );
};

export const request_productList = (
  salesChannelUuid,
  startIndex,
  maxCount,
  body,
) => {
  return post<any>(
    `/portal/salesChannelProducts/${salesChannelUuid}/${startIndex}/${maxCount}`,
    body,
    {},
  );
};

export const getAllProducts = (body) => {
  return post<any>(`/portal/salesChannelProductsPage`, body, {});
};

export const request_saveSingle = (body, params?: any) => {
  console.log('params', params);
  return post<any>(`/portal/salesChannelProduct/Single`, body, {
    afterSuccessCb: successCb,
    ...params,
  });
};

export const request_saveMulti = (body, params?: any) => {
  return post<any>(`/portal/salesChannelProduct`, body, {
    afterSuccessCb: successCb,
    ...params,
  });
};

export const request_saveGiftCard = (body, params?: any) => {
  return post<any>(`/portal/salesChannelProduct/GiftCard`, body, {
    afterSuccessCb: successCb,
    ...params,
  });
};

export const request_saveService = (body, params?: any) => {
  return post<any>(`/portal/salesChannelProduct/Service`, body, {
    afterSuccessCb: successCb,
    ...params,
  });
};

export const request_deleteProducts = (ids: Array<string>) => {
  return post<any>(`/portal/salesChannelProducts/delete`, ids, {
    afterSuccessCb: successCb,
  });
};

export const request_getVirtualProduct = (id: string, params: any) => {
  return get(`/portal/product/${id}`, params);
};

export const request_translateLinkProduct = (
  uuid: string,
  translationEnabled: boolean,
  params?: any,
) => {
  return post<any>(
    `/portal/salesChannelProduct/translation`,
    {
      uuid,
      translationEnabled,
    },
    params || {},
  );
};
export const request_translateCustomization = (
  uuid: string,
  translationEnabled: boolean,
  params?: any,
) => {
  return post<any>(
    `portal/salesChannelProductCustomisation/translation`,
    {
      uuid,
      translationEnabled,
    },
    params || {},
  );
};

const getCustomization = (
  productUuid,
  params,
): Promise<ILinkProductCustomization> => {
  return get<ILinkProductCustomization>(
    `/portal/salesChannelProductCustomisation/${productUuid}`,
    params || {},
  );
};
const submitCustomization = (
  body,
  params,
): Promise<ILinkProductCustomization> => {
  return post<ILinkProductCustomization>(
    `/portal/salesChannelProductCustomisation`,
    body,
    { ...(params || {}), afterSuccessCb: successCb },
  );
};

export { getCustomization, submitCustomization };
